<app-modal-basic #addDiscountModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">{{'admin.invoice_dealer.show.discount'|translate}}</h4>
    <button type="button" class="close basic-close" (click)="hideCollectionDiscountModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #addDiscountForm="ngForm">
      <p>{{'admin.invoice_dealer.show.modal_description'|translate}}</p>
      <p>{{'admin.invoice_dealer.show.discount_row'|translate}}</p>
      <hr>
      <ng-container *ngFor="let collectionDiscount of collectionDiscounts; let i=index">
        <div class="row">
          <div class="form-group col-md-5">
            <label>{{'doctrine.attributes.collection' | translate}}<span class="star">*</span></label>
            <ng-select required
                       [clearable]="false"
                       #collection="ngModel"
                       [name]="'collection' + i"
                       [id]="'collection' + i"
                       [items]="getCollections(collectionDiscount.collection)"
                       bindLabel="label"
                       bindValue="value"
                       [addTag]="false"
                       [hideSelected]="true"
                       [(ngModel)]="collectionDiscount.collection">
            </ng-select>
            <div class="messages text-danger"
                 *ngIf="collection.invalid && collection.dirty && collection.errors?.required">
              {{'errors.required'|translate}}
            </div>
          </div>
          <div class="form-group col-md-5">
            <label [for]="'articleName' + i">{{'doctrine.invoice_dealer.discount.amount' | translate}}<span
              class="star">*</span></label>
            <input required
                   pattern="\d+([.]\d(\d)?(\d)?)?"
                   min="1"
                   max="100"
                   [name]="'discount' + i"
                   [id]="'discount' + i"
                   class="form-control"
                   #discount="ngModel"
                   type="number"
                   [(ngModel)]="collectionDiscount.discount">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="discount.invalid && discount.dirty && discount.errors?.required">
              {{'errors.required'|translate}}
            </div>
            <div class="messages text-danger"
                 *ngIf="discount.invalid && discount.dirty && (discount.errors?.pattern || discount.errors.min || discount.errors.max)">
              {{'errors.invalid'|translate}}
            </div>
          </div>
          <div class="form-group col-md-2 mt-4">
            <a class="btn btn-lg btn-primary btn-icon ripple light ms-1" (click)="removeCollectionDiscountItem(i)">
              <i class="fa fa-remove"></i>
            </a>
          </div>
        </div>
      </ng-container>
      <button class="btn btn-primary ripple light mb-0 mt-0" (click)="addCollectionDiscountItem()">
        <i class="fa fa-plus"></i>
        &nbsp;{{'global.add' | translate}}
      </button>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="hideCollectionDiscountModal()">{{'global.cancel'|translate}}</button>
    <button class="btn btn-primary ripple light" type="button"
            (click)="SaveDiscounts()" [disabled]="!addDiscountForm.valid">
      {{'global.actions.save' | translate}}
    </button>
  </div>
</app-modal-basic>
